import React from 'react';
import { motion } from 'framer-motion';
export function BookDescription() {
  return <section className="py-24 bg-matrix-black relative px-4" data-id="element-21">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex-1" data-id="element-23">
          <div className="relative" data-id="element-24">
            <div className="absolute inset-0 bg-matrix-green blur-[80px] opacity-20" data-id="element-25"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2PR6x8ZFYA8TBdsAuLk5o4/¿Estas_listo_para_jugar_.png" alt="Libro: ¿Estás listo para jugar?" className="relative z-10 w-full max-w-md mx-auto rounded-lg shadow-2xl border border-matrix-green/20" data-id="element-26" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex-1" data-id="element-27">
          <h2 className="font-cinzel text-3xl md:text-4xl text-matrix-cream mb-6" data-id="element-28">
            Un viaje sin retorno hacia la verdad
          </h2>
          <div className="space-y-6 text-matrix-white text-lg font-light" data-id="element-29">
            <p data-id="element-30">
              Este no es un libro de autoayuda convencional. Es un manual de
              desprogramación.
            </p>
            <p data-id="element-31">
              A través de sus páginas, serás guiado paso a paso para identificar
              las líneas de código que gobiernan tu mente y aprenderás a
              reescribirlas. Es un viaje intenso, revelador y profundamente
              transformador.
            </p>
            <p className="font-medium text-matrix-cream" data-id="element-32">
              Una vez que ves los hilos, ya no puedes volver a ser la marioneta.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-6" data-id="element-33">
            <div className="border-l-2 border-matrix-green pl-4" data-id="element-34">
              <div className="text-3xl font-cinzel text-matrix-green mb-1" data-id="element-35">
                100%
              </div>
              <div className="text-sm text-matrix-white/70" data-id="element-36">
                Transformación digital
              </div>
            </div>
            <div className="border-l-2 border-matrix-green pl-4" data-id="element-37">
              <div className="text-3xl font-cinzel text-matrix-green mb-1" data-id="element-38">
                Inmediato
              </div>
              <div className="text-sm text-matrix-white/70" data-id="element-39">
                Acceso al descargar
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}